{
  "es": {
    "task_assignment": {
      "actions": {
        "confirm": "Marcar como completada",
        "create": "Tarea",
        "move_to_draft": "Poner en borrador",
        "reopen": "Reabrir",
        "send_and_notify": "Enviar y avisar"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Empleado",
        "partner": "Colaborador"
      },
      "attributes": {
        "assignee": "Responsable",
        "assignees": "Responsables",
        "created_at": "Creado",
        "due_date": "Fecha límite",
        "project": "Proyecto",
        "status": "Estado",
        "task": "Tarea",
        "unit": "Unidad"
      },
      "confirm": {
        "affected": "Esto afecta a {customers} y {team}.",
        "affected_customers": "Esto afecta a {customers}.",
        "affected_team": "Esto afecta a {team}.",
        "complete_body": "Sus tareas se cierran para ellos y desaparecen de su lista, aunque no hayan hecho nada.",
        "complete_header": "¿Cerrar esta tarea para todos?",
        "customer_tasks": "{count} tarea de cliente | {count} tareas de cliente",
        "draft_body": "La tarea desaparece hasta que se vuelva a enviar. Los correos que ya salieron siguen enviados.",
        "draft_header": "¿Volver a poner esta tarea en borrador?",
        "send_customers": "Los clientes ven la tarea de inmediato en su portal y reciben un aviso.",
        "send_header": "¿Enviar a las personas asignadas?",
        "send_permanent": "El envío no se puede deshacer. Volver a poner la tarea en borrador más tarde no retira el aviso.",
        "send_status": "Pasan a Solicitada.",
        "send_team": "Las personas del equipo reciben un aviso.",
        "team_tasks": "{count} tarea de equipo | {count} tareas de equipo"
      },
      "labels": {
        "add_assignee": "Añadir un responsable…",
        "add_customers": "Añadir clientes",
        "already_assigned": "Esta tarea ya está añadida a esta unidad.",
        "already_assigned_project": "Esta tarea ya está añadida a este proyecto.",
        "completed": "Completadas",
        "confirm_message": "¿Seguro que quieres marcar esta tarea como completada?",
        "customers": "Clientes",
        "my_tasks": "Mis tareas",
        "no_assignees": "Todavía no hay responsables.",
        "no_assignments": "Todavía no hay tareas.",
        "no_assignments_task": "Todavía no hay asignaciones para esta tarea.",
        "no_assignments_unit": "Todavía no hay tareas para esta unidad.",
        "required": "Este campo es obligatorio",
        "select_task": "Selecciona una tarea",
        "upload_hint": "Sube el documento o los documentos solicitados para completar esta tarea.",
        "uploaded_documents": "Documentos subidos"
      },
      "statuses": {
        "completed": "Completada",
        "draft": "Borrador",
        "requested": "Solicitada"
      },
      "toasts": {
        "completed": "Tarea completada",
        "create": "Tarea creada",
        "delete": "Tarea eliminada",
        "reopened": "Tarea reabierta",
        "update": "Tarea actualizada"
      }
    }
  }
}
